import { jsx as _jsx } from "react/jsx-runtime";
import { m } from 'framer-motion';
export function HoverMarkerMotionAnimation({ animationKey, children }) {
    return (_jsx(m.div, { initial: { opacity: 0, scale: 0.9 }, animate: { opacity: 1, scale: 1 }, exit: { opacity: 0, scale: 0.9 }, transition: { duration: 0.15 }, children: children }, animationKey));
}
